
import { Hierarchy } from '../../../hierarchies/domain/types'
import { Component, Vue } from '~/utility/pu-class-decorator'
import { getHierarchyRepository } from '~~/apps/hierarchies/inversify.config'
import { getSearchCountService } from '~~/apps/search/infrastructure/SearchCountsService'

@Component
export default class LowResultsAllCountries extends Vue {
  isMounted = false
  counts: Record<string, number> = {}

  countryList: Hierarchy[] = []
  async setCountryList() {
    try {
      this.countryList = await getHierarchyRepository().getCountries(
        this.$route.params.lang || 'en-gb',
      )
    } catch (error) {
      this.$sentry.captureException(error)
    }
  }

  async mounted() {
    await Promise.all([this.setCountryList(), this.updateFacetCounts()])
    this.isMounted = true
  }

  isNotLast(index: number) {
    return index !== this.countryList.length - 1
  }

  private async updateFacetCounts() {
    const results = await getSearchCountService().fetchNonPriceSearchCounts(
      this.$route.params.lang || 'en-gb',
      this.$puLangFetch,
    )
    this.counts = results?.hierarchyCounts || {}
  }
}
